//LinkedIn Learning: Learning Full-Stack Javascript Development: MongoDB, Node, and React
//ES6
import * as ContactsAPI from '../utils/ContactsAPI';


import {getFromStorage, setInStorage, removeItem} from '../utils/storage.js'

  export function authenticate(){
    this.setState({isAuthenticated: "true"})
  }

  export function signInUser(eMail, password){
    this.setState({isLoading: true})

    ContactsAPI.signInUser(eMail, password).then((session) => {
      console.log(`new session: ${JSON.stringify(session)}`);

      if(session.success !== false){

        setInStorage('the_main_app', {sessionID: session._id, userMongoID: session.userMongoID, userID: session.userID, jwt: session.userToken, userType: session.userType, userOrganization: session.userOrganization, userTeam: session.userTeam, userFirstName: session.userFirstName, userLastName: session.userLastName, timeStamp: session.timeStamp})
        //fakeAuth.authenticate()
        console.log(`session ${JSON.stringify(session)}`)
        console.log(`session is loading ${this.state.isLoading}`)
        console.log(`is Authenticated: 1 ${this.state.isAuthenticated}`)
        //have to authenticate first before setting isLoading
        this.authenticate()
        this.setState({
          isLoading: false,
          userType: session.userType,
          userOrganization: session.userOrganization,
          userTeam: session.userTeam,
          userFirstName: session.userFirstName,
          userLastName: session.userLastName,
          userLoggedInID: session.userID,

        })

        console.log('hellow form inside signIn API')
        console.log(`is Authenticated: 2 ${this.state.isAuthenticated}`)


        const obj= getFromStorage('the_main_app')

        if (obj && obj.sessionID){

          ContactsAPI.getUsers(obj.jwt).then((contacts) => {
            console.log(`contacts downloaded: ${JSON.stringify(contacts)}`);
              this.setState({users: contacts});
          });

        }

          return "Success ya know!!!!!"

      }else{
        //this.setState({isLoading: false})
        this.setState({incorrectPasswordUser: true})
      }

    });
  }

  export function logOut(){

    removeItem('the_main_app')
    //have to set isLoading to false first
    this.setState({isLoading: false})
    this.setState({isAuthenticated: false})



    ;

  }




  //Learning Resources
  //about fetch
  //https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
  //https://alligator.io/js/fetch-api/
  //https://developers.google.com/web/updates/2015/03/introduction-to-fetch
